import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext(null);
const { Consumer } = Context;

class Provider extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			activeTab : props.initialTab,
		};
	}

	onTabChange = (activeTab) => this.setState({ activeTab })

	render() {
		const { children } = this.props;

		return (
			<Context.Provider
				value={{
					...this.state,
					onTabChange : this.onTabChange,
				}}
			>
				{ children }
			</Context.Provider>
		);
	}
}

Provider.propTypes = {
	initialTab : PropTypes.number,
	children   : PropTypes.any,
};

Provider.defaultProps = {
	initialTab : 0,
	children   : null,
};

export default {
	Provider,
	Consumer,
};
